'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var hqoTheme = require('./hqo-theme-79db6cc8.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var AppThemeProvider = function (_a) {
    var children = _a.children, _b = _a.theme, theme = _b === void 0 ? hqoTheme.hqoTheme : _b;
    var updatedTheme = tslib_es6.__assign(tslib_es6.__assign({}, hqoTheme.hqoTheme), { colors: tslib_es6.__assign(tslib_es6.__assign({}, hqoTheme.hqoTheme.colors), theme.colors) });
    if (theme.fonts) {
        updatedTheme.fonts = tslib_es6.__spread(theme.fonts);
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return React__default.createElement(styled.ThemeProvider, { theme: updatedTheme }, children);
};
AppThemeProvider.defaultProps = {
    theme: undefined,
};

exports.AppThemeProvider = AppThemeProvider;
